import Modal from '@hotmart/space-lib/dist/components/modal'
import styled from 'styled-components'

export const CustomModal = styled(Modal)`
  --modal-backdrop-pointer-events: none;
`

CustomModal.displayName = 'CustomModal'

export const CustomCloseButton = styled.button`
  height: fit-content;
`

CustomCloseButton.displayName = 'CustomCloseButton'
